// extracted by mini-css-extract-plugin
export default {"list":"mantineTabs_list__xUTQE","tab":"mantineTabs_tab__Q7qo4"};